import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { iterateMyFiles } from 'pages/MyFiles/helper';

import DropDown from 'components/common/DropDown/DropDown';
import LabelWithErrors from 'components/common/LabelWithErrors/LabelWithErrors';
import TextField from 'components/common/TextField/TextField';
import requestAPI from 'utils/apiHandler';
import fieldErrorParser from 'utils/fieldErrorParser';

interface Props {
  onChange: (prop: 'subjectId' | 'documentId' | 'classId' | 'note', value: any) => void;
}
const StepOne = ({ onChange }: Props) => {
  const { t } = useTranslation();
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubjects] = useState();
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState();
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState();

  const getData = () => {
    requestAPI('/calendar/subjects').then(response => setSubjects(response));
    requestAPI('/calendar/classes').then(response => setClasses(response));
    // /myfiles returns a folder tree; the picker should offer the actual
    // lesson materials, including those nested inside folders (otherwise only
    // top-level folders like "SAMPLE" show up and their documents are hidden).
    requestAPI('/myfiles').then((response: any) => {
      const materials: any[] = [];
      iterateMyFiles(response || [], item => {
        if (item.type === 'material') {
          materials.push(item);
        }
      });
      setFiles(materials);
    });
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <DropDown
        targetElementPos="top.center"
        childrenElementPos="top.center"
        paddingHorizontal={0}
        labelProperty="title"
        idProperty="_id"
        labelAndValidation={{
          label: t('aireview:subject'),
          labelMarginTop: true,
        }}
        value={selectedSubject}
        options={subjects}
        onChange={value => {
          setSelectedSubjects(value);
          onChange('subjectId', value);
        }}
        showChevron={true}
      />
      <div className="topGreyBorder  m-1" />
      <DropDown
        targetElementPos="top.left"
        childrenElementPos="top.left"
        paddingHorizontal={0}
        labelProperty="title"
        idProperty="_id"
        labelAndValidation={{
          label: t('aireview:class'),
          labelMarginTop: true,
        }}
        value={selectedClass}
        options={classes}
        onChange={value => {
          setSelectedClass(value);
          onChange('classId', value);
        }}
        showChevron={true}
      />

      <div className="topGreyBorder  m-1" />
      <DropDown
        targetElementPos="top.left"
        childrenElementPos="bottom.left"
        paddingHorizontal={0}
        labelProperty="title"
        idProperty="_id"
        hasSearch={true}
        labelAndValidation={{
          label: t('aireview:task'),
          labelMarginTop: true,
        }}
        value={selectedFile}
        options={files}
        onChange={value => {
          setSelectedFile(value);
          onChange('documentId', value);
        }}
        showChevron={true}
      />

      <div className="topGreyBorder  m-1" />

      <LabelWithErrors
        labelAndValidation={{
          label: t('aireview:additional_description'),
        }}
        errorInfo={fieldErrorParser()}
      />

      <TextField
        multiLine={true}
        rows={4}
        placeholder={t('aireview:description_placeholder')}
        onChange={val => onChange('note', val.currentTarget.value)}
      />
    </div>
  );
};

export default StepOne;
